import { useStateInRef } from 'seagull';
import { useBusinessChannelEventBinder } from "./useBusinessChannelEventBinder";
import { useEffect } from 'react';
/** Responsible for binding to an event in the pusher business channel. */
export function BusinessChannelEventBinder(props) {
  const {
    eventName,
    source
  } = props;
  const {
    startListening
  } = useBusinessChannelEventBinder(eventName, source);
  const getProps = useStateInRef(props);
  useEffect(() => {
    startListening(event => getProps().callback(event), {
      onBind: () => {
        var _getProps$onBind, _getProps;
        return (_getProps$onBind = (_getProps = getProps()).onBind) === null || _getProps$onBind === void 0 ? void 0 : _getProps$onBind.call(_getProps);
      }
    });
  }, [eventName]);
  return null;
}